import type { FC } from 'react'

import { formatMoney } from '@/helpers'
import { getTransactionType } from '@/helpers/get-transaction-type'
import { Flex } from '@/components'
import type { T_Transaction } from '@/types/responses'
import iconIncomeSvg from '@/pages/home/img/icon-income.svg'
import iconOutgoingSvg from '@/pages/home/img/icon-outgoing.svg'
import {
  SC_TransactionsContent,
  SC_Title,
  SC_Value,
} from './styled'


interface T_TransactionCardProps {
  transaction: T_Transaction
}

export const TransactionCard: FC<T_TransactionCardProps> = ({
  transaction,
}) => {
  const isIncome = Boolean(transaction.receipt)
  const description = transaction.description?.trim() || ''

  const trimmedDescription = (
    description.length > 100
      ? description.slice(0, 100) + '...'
      : description
  )


  return (
    <Flex
      key={transaction.id}
      justify='space-between'
      align='flex-start'
      gap={16}
    >
      <Flex gap={12} align='center'>
        {transaction.receipt
          ? <img src={iconIncomeSvg} />
          : <img src={iconOutgoingSvg} />
        }

        <SC_TransactionsContent>
          <SC_Title>
            {getTransactionType(transaction)}
          </SC_Title>

          {!transaction.contractor.system && description && (
            <span>{trimmedDescription}</span>
          )}

          <p>{`${transaction.time.time}, ${transaction.time.date}`}</p>
        </SC_TransactionsContent>
      </Flex>

      <SC_Value $isIncome={isIncome}>
        {isIncome
          ? `+${formatMoney(Number(transaction.receipt?.value) || 0)}`
          : `-${formatMoney(Number(transaction.expense?.value) || 0)}`
        }
      </SC_Value>
    </Flex>
  )
}
